import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { Size2b01934yxlz5f as Size } from '../../models/Rect.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  coerceIn10fbf4zn2whhq as coerceIn,
  until1jbpn0z3f8lbg as until,
  coerceIn1xblvmyr0tby6 as coerceIn_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  SpecificElement1fm8kkyg4nw48 as SpecificElement,
  FuzzyIndex1f984se19g5yx as FuzzyIndex,
} from './RecyclerViewAnchor.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { asSequence2phdjljfh9jhx as asSequence } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { estimateJumpAnchor3fhl00o07marf as estimateJumpAnchor } from './Recycler2.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var RecyclerViewPlacerVerticalGridClass;
function RecyclerViewPlacerVerticalGrid() {
  if (RecyclerViewPlacerVerticalGridClass === VOID) {
    class $ {
      constructor(columns, ratio, sizeDoesNotChange) {
        ratio = ratio === VOID ? null : ratio;
        sizeDoesNotChange = sizeDoesNotChange === VOID ? false : sizeDoesNotChange;
        this.columns_1 = columns;
        this.ratio_1 = ratio;
        this.sizeDoesNotChange_1 = sizeDoesNotChange;
        // Inline function 'kotlin.require' call
        if (!(this.columns_1 > 0)) {
          var message = 'RecyclerViewPlacerVerticalGrid needs at least one column, got ' + this.columns_1;
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        this.sizeByType_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
        this.log_1 = null;
      }
      height_wzuf13_k$(_this__u8e3s4, cellSize) {
        var tmp0_safe_receiver = this.ratio_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = cellSize * tmp0_safe_receiver;
        }
        var tmp1_elvis_lhs = tmp;
        var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? this.sizeByType_1.get_wei43m_k$(_this__u8e3s4.get_type_wovaf7_k$()) : tmp1_elvis_lhs;
        var tmp_0;
        if (tmp2_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = _this__u8e3s4.get_size_woubt6_k$().height_1;
          if (this.sizeDoesNotChange_1) {
            var tmp0 = this.sizeByType_1;
            // Inline function 'kotlin.collections.set' call
            var key = _this__u8e3s4.get_type_wovaf7_k$();
            tmp0.put_4fpzoq_k$(key, this_0);
          }
          tmp_0 = this_0;
        } else {
          tmp_0 = tmp2_elvis_lhs;
        }
        return tmp_0;
      }
      existingHeight_c5dtjo_k$(_this__u8e3s4, cellSize) {
        var tmp0_safe_receiver = this.ratio_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = cellSize * tmp0_safe_receiver;
        }
        var tmp1_elvis_lhs = tmp;
        var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? this.sizeByType_1.get_wei43m_k$(_this__u8e3s4.get_type_wovaf7_k$()) : tmp1_elvis_lhs;
        var tmp_0;
        if (tmp2_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = _this__u8e3s4.get_bottom_bj8ras_k$() - _this__u8e3s4.get_top_18ivbo_k$();
          if (this.sizeDoesNotChange_1) {
            var tmp0 = this.sizeByType_1;
            // Inline function 'kotlin.collections.set' call
            var key = _this__u8e3s4.get_type_wovaf7_k$();
            tmp0.put_4fpzoq_k$(key, this_0);
          }
          tmp_0 = this_0;
        } else {
          tmp_0 = tmp2_elvis_lhs;
        }
        return tmp_0;
      }
      place_wvys22_k$(dataRange, anchor, previousViewport, existingCells, getNewCell, viewport, overdraw, paddingTop, paddingLeft, paddingRight, paddingBottom, gap) {
        var cellSize = (viewport.right_1 - viewport.left_1 - paddingLeft - paddingRight - (this.columns_1 - 1 | 0) * gap) / this.columns_1;
        var constrain = new (Size())(cellSize, 10000.0);
        var tmp = 0;
        var tmp_0 = this.columns_1;
        var tmp_1 = new Float64Array(tmp_0);
        while (tmp < tmp_0) {
          var tmp_2 = tmp;
          tmp_1[tmp_2] = paddingTop + tmp_2 * gap + tmp_2 * cellSize;
          tmp = tmp + 1 | 0;
        }
        var cellOffsets = tmp_1;
        var tmp_3;
        if (anchor == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_4;
          if (anchor instanceof FuzzyIndex()) {
            // Inline function 'kotlin.collections.sumOf' call
            var sum = 0;
            var _iterator__ex2g4s = existingCells.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              var tmp_5 = sum;
              sum = tmp_5 + this.existingHeight_c5dtjo_k$(element, cellSize);
            }
            var averageRowHeight = sum / existingCells.get_size_woubt6_k$();
            var focusRowIndex = imul(numberToInt(coerceIn_0(anchor.index_1, dataRange.first_1, dataRange.last_1) / this.columns_1), this.columns_1);
            var partialIndexOffset = anchor.index_1 % this.columns_1 / this.columns_1 * averageRowHeight;
            tmp_4 = to(viewport.top_1 + (viewport.get_height_e7t92o_k$() - paddingTop - paddingBottom) * anchor.ratioOfFocus_1 - partialIndexOffset, focusRowIndex);
          } else {
            if (anchor instanceof SpecificElement()) {
              var currentIndex = imul(coerceIn(anchor.index_1, dataRange) / this.columns_1 | 0, this.columns_1);
              // Inline function 'kotlin.collections.map' call
              var this_0 = until(0, this.columns_1);
              // Inline function 'kotlin.collections.mapTo' call
              var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
              var inductionVariable = this_0.first_1;
              var last = this_0.last_1;
              if (inductionVariable <= last)
                do {
                  var item = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var it = item;
                  var tmp_6;
                  var containsLower = dataRange.first_1;
                  var containsUpper = dataRange.last_1;
                  var containsArg = currentIndex + it | 0;
                  if (containsLower <= containsArg ? containsArg <= containsUpper : false) {
                    tmp_6 = getNewCell(currentIndex + it | 0, constrain);
                  } else {
                    tmp_6 = null;
                  }
                  var tmp$ret$7 = tmp_6;
                  destination.add_utx5q5_k$(tmp$ret$7);
                }
                 while (!(item === last));
              var cells = destination;
              // Inline function 'kotlin.collections.maxOf' call
              var iterator = cells.iterator_jk1svi_k$();
              if (!iterator.hasNext_bitz1p_k$())
                throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
              var tmp0_safe_receiver = iterator.next_20eer_k$();
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.height_wzuf13_k$(tmp0_safe_receiver, cellSize);
              var maxValue = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
              while (iterator.hasNext_bitz1p_k$()) {
                var tmp0_safe_receiver_0 = iterator.next_20eer_k$();
                var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : this.height_wzuf13_k$(tmp0_safe_receiver_0, cellSize);
                var v = tmp1_elvis_lhs_0 == null ? 0.0 : tmp1_elvis_lhs_0;
                // Inline function 'kotlin.comparisons.maxOf' call
                var a = maxValue;
                maxValue = Math.max(a, v);
              }
              var max = maxValue;
              var tmp0 = anchor.align_1.ordinal_1;
              tmp_4 = to(tmp0 === 0 ? viewport.top_1 + paddingTop : tmp0 === 2 ? viewport.bottom_1 - max - paddingBottom : viewport.get_centerY_c9mbwb_k$() - max / 2, currentIndex);
            } else {
              noWhenBranchMatchedException();
            }
          }
          tmp_3 = tmp_4;
        }
        var tmp1_elvis_lhs_1 = tmp_3;
        var tmp_7;
        if (tmp1_elvis_lhs_1 == null) {
          var tmp0_0 = asSequence(existingCells);
          var tmp$ret$12;
          $l$block_0: {
            // Inline function 'kotlin.sequences.minByOrNull' call
            var iterator_0 = tmp0_0.iterator_jk1svi_k$();
            if (!iterator_0.hasNext_bitz1p_k$()) {
              tmp$ret$12 = null;
              break $l$block_0;
            }
            var minElem = iterator_0.next_20eer_k$();
            if (!iterator_0.hasNext_bitz1p_k$()) {
              tmp$ret$12 = minElem;
              break $l$block_0;
            }
            var it_0 = minElem;
            var tmp_8 = it_0.get_centerX_c9mbwa_k$();
            // Inline function 'kotlin.math.abs' call
            var x = viewport.top_1 - it_0.get_top_18ivbo_k$();
            var minValue = tmp_8 + Math.abs(x) + (it_0.get_top_18ivbo_k$() <= overdraw.top_1 ? 10000 : 0);
            do {
              var e = iterator_0.next_20eer_k$();
              var tmp_9 = e.get_centerX_c9mbwa_k$();
              // Inline function 'kotlin.math.abs' call
              var x_0 = viewport.top_1 - e.get_top_18ivbo_k$();
              var v_0 = tmp_9 + Math.abs(x_0) + (e.get_top_18ivbo_k$() <= overdraw.top_1 ? 10000 : 0);
              if (compareTo(minValue, v_0) > 0) {
                minElem = e;
                minValue = v_0;
              }
            }
             while (iterator_0.hasNext_bitz1p_k$());
            tmp$ret$12 = minElem;
          }
          var tmp2_safe_receiver = tmp$ret$12;
          var tmp_10;
          if (tmp2_safe_receiver == null) {
            tmp_10 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp0_safe_receiver_1 = this.log_1;
            if (tmp0_safe_receiver_1 == null)
              null;
            else {
              tmp0_safe_receiver_1.log_iyb52q_k$(['Using existing cells for anchor: ' + tmp2_safe_receiver.get_top_18ivbo_k$() + ' to ' + tmp2_safe_receiver.get_index_it478p_k$() + ' => ' + imul(tmp2_safe_receiver.get_index_it478p_k$() / this.columns_1 | 0, this.columns_1)]);
            }
            tmp_10 = to(tmp2_safe_receiver.get_top_18ivbo_k$(), imul(tmp2_safe_receiver.get_index_it478p_k$() / this.columns_1 | 0, this.columns_1));
          }
          tmp_7 = tmp_10;
        } else {
          tmp_7 = tmp1_elvis_lhs_1;
        }
        var tmp3_elvis_lhs = tmp_7;
        var tmp_11;
        if (tmp3_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var tmp$ret$20;
          $l$block_1: {
            var tmp0_elvis_lhs = estimateJumpAnchor(existingCells, true, viewport);
            var tmp_12;
            if (tmp0_elvis_lhs == null) {
              tmp$ret$20 = null;
              break $l$block_1;
            } else {
              tmp_12 = tmp0_elvis_lhs;
            }
            var it_1 = tmp_12;
            var tmp1_safe_receiver = this.log_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              tmp1_safe_receiver.log_iyb52q_k$(['estimateJumpAnchor got ' + it_1.toString()]);
            }
            // Inline function 'kotlin.collections.sumOf' call
            var sum_0 = 0;
            var _iterator__ex2g4s_0 = existingCells.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
              var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
              var tmp_13 = sum_0;
              sum_0 = tmp_13 + this.height_wzuf13_k$(element_0, cellSize);
            }
            var averageRowHeight_0 = sum_0 / existingCells.get_size_woubt6_k$();
            var focusRowIndex_0 = imul(numberToInt(coerceIn_0(it_1.index_1, dataRange.first_1, dataRange.last_1) / this.columns_1), this.columns_1);
            var partialIndexOffset_0 = it_1.index_1 % this.columns_1 / this.columns_1 * averageRowHeight_0;
            tmp$ret$20 = to(viewport.top_1 + viewport.get_height_e7t92o_k$() * it_1.ratioOfFocus_1 - partialIndexOffset_0, focusRowIndex_0);
          }
          tmp_11 = tmp$ret$20;
        } else {
          tmp_11 = tmp3_elvis_lhs;
        }
        var tmp4_elvis_lhs = tmp_11;
        var tmp_14;
        if (tmp4_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var tmp0_safe_receiver_2 = this.log_1;
          if (tmp0_safe_receiver_2 == null)
            null;
          else {
            tmp0_safe_receiver_2.log_iyb52q_k$(['estimateJumpAnchor was dumped; no existin cells?']);
          }
          tmp_14 = to(viewport.top_1 + paddingTop, imul(dataRange.first_1 / this.columns_1 | 0, this.columns_1));
        } else {
          tmp_14 = tmp4_elvis_lhs;
        }
        // Inline function 'kotlin.let' call
        var it_2 = tmp_14;
        var tmp_15;
        if (it_2.second_1 < (dataRange.first_1 - this.columns_1 | 0)) {
          var tmp0_safe_receiver_3 = this.log_1;
          if (tmp0_safe_receiver_3 == null)
            null;
          else {
            tmp0_safe_receiver_3.log_iyb52q_k$(['Anchor ignored due to out-of-range']);
          }
          tmp_15 = to(viewport.top_1 + paddingTop, imul(dataRange.first_1 / this.columns_1 | 0, this.columns_1));
        } else if (it_2.second_1 > (dataRange.last_1 + this.columns_1 | 0)) {
          var tmp1_safe_receiver_0 = this.log_1;
          if (tmp1_safe_receiver_0 == null)
            null;
          else {
            tmp1_safe_receiver_0.log_iyb52q_k$(['Anchor ignored due to out-of-range']);
          }
          var currentIndex_0 = imul(dataRange.last_1 / this.columns_1 | 0, this.columns_1);
          // Inline function 'kotlin.collections.map' call
          var this_1 = until(0, this.columns_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_1, 10));
          var inductionVariable_0 = this_1.first_1;
          var last_0 = this_1.last_1;
          if (inductionVariable_0 <= last_0)
            do {
              var item_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var it_3 = item_0;
              var tmp_16;
              var containsLower_0 = dataRange.first_1;
              var containsUpper_0 = dataRange.last_1;
              var containsArg_0 = currentIndex_0 + it_3 | 0;
              if (containsLower_0 <= containsArg_0 ? containsArg_0 <= containsUpper_0 : false) {
                tmp_16 = getNewCell(currentIndex_0 + it_3 | 0, constrain);
              } else {
                tmp_16 = null;
              }
              var tmp$ret$29 = tmp_16;
              destination_0.add_utx5q5_k$(tmp$ret$29);
            }
             while (!(item_0 === last_0));
          var cells_0 = destination_0;
          // Inline function 'kotlin.collections.maxOf' call
          var iterator_1 = cells_0.iterator_jk1svi_k$();
          if (!iterator_1.hasNext_bitz1p_k$())
            throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
          var tmp0_safe_receiver_4 = iterator_1.next_20eer_k$();
          var tmp1_elvis_lhs_2 = tmp0_safe_receiver_4 == null ? null : this.height_wzuf13_k$(tmp0_safe_receiver_4, cellSize);
          var maxValue_0 = tmp1_elvis_lhs_2 == null ? 0.0 : tmp1_elvis_lhs_2;
          while (iterator_1.hasNext_bitz1p_k$()) {
            var tmp0_safe_receiver_5 = iterator_1.next_20eer_k$();
            var tmp1_elvis_lhs_3 = tmp0_safe_receiver_5 == null ? null : this.height_wzuf13_k$(tmp0_safe_receiver_5, cellSize);
            var v_1 = tmp1_elvis_lhs_3 == null ? 0.0 : tmp1_elvis_lhs_3;
            // Inline function 'kotlin.comparisons.maxOf' call
            var a_0 = maxValue_0;
            maxValue_0 = Math.max(a_0, v_1);
          }
          var max_0 = maxValue_0;
          tmp_15 = to(viewport.bottom_1 - max_0 - paddingBottom, currentIndex_0);
        } else {
          tmp_15 = it_2;
        }
        var _destruct__k2r9zo = tmp_15;
        var anchorRowY = _destruct__k2r9zo.component1_7eebsc_k$();
        var anchorRowIndex = _destruct__k2r9zo.component2_7eebsb_k$();
        var tmp5_safe_receiver = this.log_1;
        if (tmp5_safe_receiver == null)
          null;
        else {
          tmp5_safe_receiver.log_iyb52q_k$(['ANCHOR ' + anchorRowY + ' gets index ' + anchorRowIndex]);
        }
        var currentY = anchorRowY;
        var currentIndex_1 = anchorRowIndex;
        while (currentY < overdraw.bottom_1 && currentIndex_1 <= dataRange.last_1) {
          // Inline function 'kotlin.collections.map' call
          var this_2 = until(0, this.columns_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_2, 10));
          var inductionVariable_1 = this_2.first_1;
          var last_1 = this_2.last_1;
          if (inductionVariable_1 <= last_1)
            do {
              var item_1 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var it_4 = item_1;
              var tmp_17;
              var containsLower_1 = dataRange.first_1;
              var containsUpper_1 = dataRange.last_1;
              var containsArg_1 = currentIndex_1 + it_4 | 0;
              if (containsLower_1 <= containsArg_1 ? containsArg_1 <= containsUpper_1 : false) {
                tmp_17 = getNewCell(currentIndex_1 + it_4 | 0, constrain);
              } else {
                tmp_17 = null;
              }
              var tmp$ret$36 = tmp_17;
              destination_1.add_utx5q5_k$(tmp$ret$36);
            }
             while (!(item_1 === last_1));
          var cells_1 = destination_1;
          // Inline function 'kotlin.collections.maxOf' call
          var iterator_2 = cells_1.iterator_jk1svi_k$();
          if (!iterator_2.hasNext_bitz1p_k$())
            throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
          var tmp0_safe_receiver_6 = iterator_2.next_20eer_k$();
          var tmp1_elvis_lhs_4 = tmp0_safe_receiver_6 == null ? null : this.height_wzuf13_k$(tmp0_safe_receiver_6, cellSize);
          var maxValue_1 = tmp1_elvis_lhs_4 == null ? 0.0 : tmp1_elvis_lhs_4;
          while (iterator_2.hasNext_bitz1p_k$()) {
            var tmp0_safe_receiver_7 = iterator_2.next_20eer_k$();
            var tmp1_elvis_lhs_5 = tmp0_safe_receiver_7 == null ? null : this.height_wzuf13_k$(tmp0_safe_receiver_7, cellSize);
            var v_2 = tmp1_elvis_lhs_5 == null ? 0.0 : tmp1_elvis_lhs_5;
            // Inline function 'kotlin.comparisons.maxOf' call
            var a_1 = maxValue_1;
            maxValue_1 = Math.max(a_1, v_2);
          }
          var max_1 = maxValue_1;
          var inductionVariable_2 = 0;
          var last_2 = this.columns_1;
          if (inductionVariable_2 < last_2)
            do {
              var i = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var tmp6_safe_receiver = cells_1.get_c1px32_k$(i);
              if (tmp6_safe_receiver == null)
                null;
              else {
                tmp6_safe_receiver.place_2acamh_k$(cellOffsets[i], currentY, cellOffsets[i] + cellSize, currentY + max_1);
              }
            }
             while (inductionVariable_2 < last_2);
          currentY = currentY + (max_1 + gap);
          currentIndex_1 = currentIndex_1 + this.columns_1 | 0;
        }
        currentY = anchorRowY - gap;
        currentIndex_1 = anchorRowIndex - this.columns_1 | 0;
        while (currentY > overdraw.top_1 && ((currentIndex_1 + this.columns_1 | 0) - 1 | 0) >= dataRange.first_1) {
          // Inline function 'kotlin.collections.map' call
          var this_3 = until(0, this.columns_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination_2 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_3, 10));
          var inductionVariable_3 = this_3.first_1;
          var last_3 = this_3.last_1;
          if (inductionVariable_3 <= last_3)
            do {
              var item_2 = inductionVariable_3;
              inductionVariable_3 = inductionVariable_3 + 1 | 0;
              var it_5 = item_2;
              var tmp_18;
              var containsLower_2 = dataRange.first_1;
              var containsUpper_2 = dataRange.last_1;
              var containsArg_2 = currentIndex_1 + it_5 | 0;
              if (containsLower_2 <= containsArg_2 ? containsArg_2 <= containsUpper_2 : false) {
                tmp_18 = getNewCell(currentIndex_1 + it_5 | 0, constrain);
              } else {
                tmp_18 = null;
              }
              var tmp$ret$43 = tmp_18;
              destination_2.add_utx5q5_k$(tmp$ret$43);
            }
             while (!(item_2 === last_3));
          var cells_2 = destination_2;
          // Inline function 'kotlin.collections.maxOf' call
          var iterator_3 = cells_2.iterator_jk1svi_k$();
          if (!iterator_3.hasNext_bitz1p_k$())
            throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
          var tmp0_safe_receiver_8 = iterator_3.next_20eer_k$();
          var tmp1_elvis_lhs_6 = tmp0_safe_receiver_8 == null ? null : this.height_wzuf13_k$(tmp0_safe_receiver_8, cellSize);
          var maxValue_2 = tmp1_elvis_lhs_6 == null ? 0.0 : tmp1_elvis_lhs_6;
          while (iterator_3.hasNext_bitz1p_k$()) {
            var tmp0_safe_receiver_9 = iterator_3.next_20eer_k$();
            var tmp1_elvis_lhs_7 = tmp0_safe_receiver_9 == null ? null : this.height_wzuf13_k$(tmp0_safe_receiver_9, cellSize);
            var v_3 = tmp1_elvis_lhs_7 == null ? 0.0 : tmp1_elvis_lhs_7;
            // Inline function 'kotlin.comparisons.maxOf' call
            var a_2 = maxValue_2;
            maxValue_2 = Math.max(a_2, v_3);
          }
          var max_2 = maxValue_2;
          var inductionVariable_4 = 0;
          var last_4 = this.columns_1;
          if (inductionVariable_4 < last_4)
            do {
              var i_0 = inductionVariable_4;
              inductionVariable_4 = inductionVariable_4 + 1 | 0;
              var tmp7_safe_receiver = cells_2.get_c1px32_k$(i_0);
              if (tmp7_safe_receiver == null)
                null;
              else {
                tmp7_safe_receiver.place_2acamh_k$(cellOffsets[i_0], currentY - max_2, cellOffsets[i_0] + cellSize, currentY);
              }
            }
             while (inductionVariable_4 < last_4);
          currentY = currentY - (max_2 + gap);
          currentIndex_1 = currentIndex_1 - this.columns_1 | 0;
        }
      }
    }
    initMetadataForClass($, 'RecyclerViewPlacerVerticalGrid');
    RecyclerViewPlacerVerticalGridClass = $;
  }
  return RecyclerViewPlacerVerticalGridClass;
}
//region block: exports
export {
  RecyclerViewPlacerVerticalGrid as RecyclerViewPlacerVerticalGrid1jojlivaz3vdj,
};
//endregion

//# sourceMappingURL=RecyclerViewPlacerVerticalGrid.mjs.map
